import {createRouter, createWebHashHistory} from 'vue-router'

import BasketView from '@/views/Basket.vue'
import ContactDetailsView from '@/views/ContactDetails.vue'
import DeliveryDetailsView from '@/views/DeliveryDetails.vue'
import PaymentDetailsView from '@/views/PaymentDetails.vue'
import PickupDetailsView from '@/views/PickupDetails.vue'
import NotFound from '@/views/NotFound.vue'

const routes = [
  {
    path: '/',
    name: 'basket',
    component: BasketView
  },
  {
    path: '/contact-details',
    name: 'contact-details',
    component: ContactDetailsView,
  },
  {
    path: '/delivery-details',
    name: 'delivery-details',
    component: DeliveryDetailsView,
  },
  {
    path: '/pickup-details',
    name: 'pickup-details',
    component: PickupDetailsView,
  },
  {
    path: '/payment-details',
    name: 'payment-details',
    component: PaymentDetailsView,
  },
  {
    path: "/:pathMatch(.*)*",
    name: "NotFound",
    component: NotFound
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes, // short for `routes: routes`
  linkActiveClass: "activeNav",
  scrollBehavior(to, from, savedPosition) {
    // reset location to top of page
    return { top: 0 }
  },
})

export default router
